class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartNotification = this.closest("cart-notification");
      const productElement = this.closest(".cart-notification-product");

      if (cartNotification) {
        cartNotification.updateQuantity(this.dataset.index, 0);
      }

      if (productElement) {
        productElement.classList.add("loading");

        if (productElement.firstElementChild) {
          productElement.firstElementChild.classList.remove("hidden");
        }
      }
    });
  }
}

customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (event) => {
          if (event.code === "Escape") {
            this.close();
          }
        }
      );

      this.notification.addEventListener("click", (event) => {
        if (
          event.target.classList.contains("cart-notification__close") ||
          event.target.closest(".cart-notification__close")
        ) {
          this.close();
        }
      });
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => {
      return total + parseInt(quantityInput.value, 10);
    }, 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );
  }

  onChange(event) {
    if (
      !event.target.closest("select") &&
      !event.target.closest('[name="attributes[gift-wrapping]"]') &&
      !event.target.closest('[name="note"]') &&
      !event.target.closest("shipping-calculator") &&
      !event.target.closest("discount-code") &&
      !event.target.closest("gift-wrap-message")
    ) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement?.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );

      document
        .querySelector(".cart_action_drawer_overlay")
        ?.classList.add("active");
    }
  }

  open() {
    if (!this.notification) {
      return;
    }

    this.notification.classList.add("animate", "active");
    document.body.classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener(
      "click",
      this.onBodyClick
    );
  }

  close() {
    document
      .getElementById("mini-cart-drawer")
      ?.classList.remove("active");

    document.body.classList.remove("added__overlay");

    document.body.removeEventListener(
      "click",
      this.onBodyClick
    );
  }

  renderContents(parsedState, skipOpen = false) {
    if (!parsedState || !parsedState.sections || !parsedState.sections["mini-cart-drawer"]) {
      return this.refresh().then(() => {
        if (!skipOpen) this.open();
      });
    }

    this.getSectionsToRender().forEach((section) => {
      const renderSelector = document.getElementById(section.id);

      if (
        renderSelector &&
        parsedState.sections &&
        parsedState.sections[section.id]
      ) {
        renderSelector.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id]
        );
      }
    });

    const mobileCartCount = document.getElementById(
      "cart-notification-count-mobile"
    );

    if (
      mobileCartCount &&
      parsedState.sections &&
      parsedState.sections["cart-notification-count"]
    ) {
      mobileCartCount.innerHTML = this.getSectionInnerHTML(
        parsedState.sections["cart-notification-count"]
      );
    }

    if (
      this.header &&
      typeof this.header.reveal === "function"
    ) {
      this.header.reveal();
    }

    if (!skipOpen) {
      this.open();
    }
  }

  async refresh() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const response = await fetch(
        `${root}?sections=mini-cart-drawer,cart-notification-count&nk=${Date.now()}`,
        { cache: "no-store", credentials: "same-origin", headers: { Accept: "application/json" } }
      );
      if (!response.ok) return;
      const sections = await response.json();
      if (sections && sections["mini-cart-drawer"]) {
        this.renderContents({ sections: sections }, true);
      }
    } catch (error) {
      console.error("Cart drawer refresh error:", error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart-drawer"
      },
      {
        id: "cart-notification-count"
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        (section) => section.id
      ),
      sections_url: window.location.pathname
    });

    document
      .querySelector(".cart_action_drawer_overlay")
      ?.classList.add("active");

    fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement = document.getElementById(
          `Quantity-${line}`
        );

        const items = document.querySelectorAll(
          ".cart-notification-product"
        );

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value =
              quantityElement.getAttribute("value");
          }

          this.updateLiveRegions(
            line,
            parsedState.errors
          );

          return;
        }

        this.renderContents(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = "";

        if (
          quantityElement &&
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value, 10)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }

        this.updateLiveRegions(line, message);

        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-notification",
            cartData: parsedState,
            variantId
          });
        }
      })
      .catch((error) => {
        console.error("Cart update error:", error);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          ?.classList.remove("active");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(
      `Line-item-error-${line}`
    );

    if (!lineItemError) {
      return;
    }

    const errorText = lineItemError.querySelector(
      ".cart-item__error-text"
    );

    if (!message) {
      lineItemError.classList.add("d-none");

      if (errorText) {
        errorText.innerHTML = "";
      }

      return;
    }

    lineItemError.classList.remove("d-none");

    if (errorText) {
      errorText.innerHTML = message;
    }
  }

  getSectionInnerHTML(
    html,
    selector = ".shopify-section"
  ) {
    if (!html) {
      return "";
    }

    const parsedDocument = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    const selectedElement =
      parsedDocument.querySelector(selector);

    return selectedElement
      ? selectedElement.innerHTML
      : "";
  }

  handleBodyClick(event) {
    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  "cart-notification",
  CartNotification
);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification =
      document.getElementById("mini-cart-drawer");

    this.onBodyClassRemove =
      this.handleBodyClass.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (event) => {
          if (event.code === "Escape") {
            this.miniCartClose();
          }
        }
      );
    }
  }

  onClickMiniCart() {
    document.querySelector("cart-notification")?.refresh?.();

    if (!this.notification) {
      return;
    }

    this.notification.classList.add(
      "animate",
      "active"
    );

    document.body.classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();

        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener(
      "click",
      this.onBodyClassRemove
    );
  }

  miniCartClose() {
    document
      .getElementById("mini-cart-drawer")
      ?.classList.remove("active");

    document.body.classList.remove("added__overlay");

    document.body.removeEventListener(
      "click",
      this.onBodyClassRemove
    );

    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(
        document.querySelector(
          ".header__actions_btn--cart"
        )
      );
    }
  }

  handleBodyClass(event) {
    const eventTarget = event.target;

    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}

customElements.define(
  "open-minicart",
  OpenMiniCart
);

/* Sidan visas från bakåt/framåt-cachen (Safari m.fl.): hämta aktuell varukorg. */
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    document.querySelector("cart-notification")?.refresh?.();
  }
});


/* ==========================================================
   UPSSELL LANGUAGE
   Sverige / Norge / Danmark
   ========================================================== */

const NK_UPSELL_LANGUAGE = (function () {
  const locale = String(
    (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      ""
  ).toLowerCase();

  if (
    locale.startsWith("da") ||
    window.location.pathname.startsWith("/da-dk")
  ) {
    return "da";
  }

  if (
    locale.startsWith("nb") ||
    locale.startsWith("no") ||
    locale.startsWith("nn")
  ) {
    return "no";
  }

  return "sv";
})();


const NK_UPSELL_TEXTS = {
  sv: {
    unavailable: "Ej tillgänglig",
    add: "Lägg till",
    soldOut: "Slutsåld",
    adding: "Lägger till…",
    addFailed: "Produkten kunde inte läggas till.",
    addFailedRetry: "Produkten kunde inte läggas till. Försök igen.",
    cartUpdateFailed: "Varukorgen kunde inte uppdateras.",
    moneyLocale: "sv-SE"
  },

  no: {
    unavailable: "Ikke tilgjengelig",
    add: "Legg til",
    soldOut: "Utsolgt",
    adding: "Legger til…",
    addFailed: "Produktet kunne ikke legges til.",
    addFailedRetry: "Produktet kunne ikke legges til. Prøv igjen.",
    cartUpdateFailed: "Handlekurven kunne ikke oppdateres.",
    moneyLocale: "nb-NO"
  },

  da: {
    unavailable: "Ikke tilgængelig",
    add: "Tilføj",
    soldOut: "Udsolgt",
    adding: "Tilføjer…",
    addFailed: "Produktet kunne ikke tilføjes.",
    addFailedRetry: "Produktet kunne ikke tilføjes. Prøv igen.",
    cartUpdateFailed: "Kurven kunne ikke opdateres.",
    moneyLocale: "da-DK"
  }
};


const NK_UPSELL_TEXT =
  NK_UPSELL_TEXTS[NK_UPSELL_LANGUAGE];


if (!customElements.get("cart-upsell")) {
  customElements.define(
    "cart-upsell",
    class CartUpsell extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(
          "[data-cart-upsell-button]"
        );

        this.errorMessage = this.querySelector(
          "[data-cart-upsell-error]"
        );

        this.priceElement = this.querySelector(
          "[data-upsell-price]"
        );

        this.comparePriceElement = this.querySelector(
          "[data-upsell-compare-price]"
        );

        this.imageElement = this.querySelector(
          "[data-upsell-image]"
        );

        this.optionSelects = Array.from(
          this.querySelectorAll(
            "[data-upsell-option]"
          )
        );

        const variantsElement = this.querySelector(
          "[data-upsell-variants]"
        );

        try {
          this.variants = variantsElement
            ? JSON.parse(
                variantsElement.textContent
              )
            : [];
        } catch (error) {
          console.error(
            "Cart upsell: kunde inte läsa varianterna.",
            error
          );

          this.variants = [];
        }

        this.variantId = Number(
          this.dataset.variantId || 0
        );

        this.optionSelects.forEach((select) => {
          select.addEventListener(
            "change",
            () => {
              this.updateSelectedVariant();
            }
          );
        });

        if (this.button) {
          this.button.addEventListener(
            "click",
            () => {
              this.addProduct();
            }
          );
        }

        this.updateSelectedVariant();
      }


      formatMoney(cents) {
        const currency =
          window.Shopify?.currency?.active ||
          "SEK";

        try {
          return new Intl.NumberFormat(
            NK_UPSELL_TEXT.moneyLocale,
            {
              style: "currency",
              currency: currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            }
          ).format(
            Number(cents || 0) / 100
          );
        } catch (error) {
          return (
            Number(cents || 0) / 100
          )
            .toFixed(2)
            .replace(".", ",") + " kr";
        }
      }


      getSelectedVariant() {
        if (!this.variants.length) {
          return null;
        }

        if (!this.optionSelects.length) {
          return (
            this.variants.find(
              (variant) =>
                Number(variant.id) ===
                Number(this.variantId)
            ) ||
            this.variants.find(
              (variant) =>
                variant.available
            ) ||
            this.variants[0]
          );
        }

        const selectedOptions =
          this.optionSelects.map(
            (select) => select.value
          );

        return this.variants.find(
          (variant) => {
            return variant.options.every(
              (
                optionValue,
                index
              ) => {
                return (
                  String(optionValue) ===
                  String(
                    selectedOptions[index]
                  )
                );
              }
            );
          }
        );
      }


      updateSelectedVariant() {
        const selectedVariant =
          this.getSelectedVariant();

        if (!selectedVariant) {
          this.variantId = null;

          if (this.button) {
            this.button.disabled = true;

            this.button.innerHTML =
              "<span>" +
              NK_UPSELL_TEXT.unavailable +
              "</span>";
          }

          return;
        }

        this.variantId = Number(
          selectedVariant.id
        );

        this.dataset.variantId = String(
          selectedVariant.id
        );

        if (
          this.imageElement &&
          selectedVariant.image
        ) {
          this.imageElement.src =
            selectedVariant.image;

          this.imageElement.srcset = "";

          this.imageElement.removeAttribute(
            "sizes"
          );
        }

        if (this.priceElement) {
          this.priceElement.textContent =
            this.formatMoney(
              selectedVariant.price
            );
        }

        const comparePrice = Number(
          selectedVariant.compare_at_price ||
            0
        );

        const currentPrice = Number(
          selectedVariant.price || 0
        );

        const hasDiscount =
          comparePrice > currentPrice;

        if (this.comparePriceElement) {
          this.comparePriceElement.hidden =
            !hasDiscount;

          if (hasDiscount) {
            this.comparePriceElement.textContent =
              this.formatMoney(
                comparePrice
              );
          }
        }

        if (this.button) {
          this.button.disabled =
            !selectedVariant.available;

          if (
            selectedVariant.available
          ) {
            this.button.innerHTML =
              '<span class="cart-row-upsell__plus">+</span>' +
              "<span>" +
              NK_UPSELL_TEXT.add +
              "</span>";
          } else {
            this.button.innerHTML =
              "<span>" +
              NK_UPSELL_TEXT.soldOut +
              "</span>";
          }
        }

        if (this.errorMessage) {
          this.errorMessage.hidden = true;
          this.errorMessage.textContent =
            "";
        }
      }


      async getFreshSections() {
        const separator =
          window.location.search
            ? "&"
            : "?";

        const url =
          window.location.pathname +
          window.location.search +
          separator +
          "sections=mini-cart-drawer,cart-notification-count";

        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {
              Accept:
                "application/json"
            },
            credentials:
              "same-origin",
            cache:
              "no-store"
          }
        );

        if (!response.ok) {
          throw new Error(
            NK_UPSELL_TEXT.cartUpdateFailed
          );
        }

        return response.json();
      }


      async addProduct() {
        const selectedVariant =
          this.getSelectedVariant();

        if (
          !selectedVariant ||
          !selectedVariant.available ||
          !this.button
        ) {
          return;
        }

        this.variantId = Number(
          selectedVariant.id
        );

        const originalHTML =
          this.button.innerHTML;

        this.button.disabled = true;

        this.button.setAttribute(
          "aria-busy",
          "true"
        );

        this.button.innerHTML =
          "<span>" +
          NK_UPSELL_TEXT.adding +
          "</span>";

        if (this.errorMessage) {
          this.errorMessage.hidden = true;
        }

        const root =
          window.Shopify?.routes?.root ||
          "/";

        const sections = [
          "mini-cart-drawer",
          "cart-notification-count"
        ];

        try {
          const response = await fetch(
            root + "cart/add.js",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
                Accept:
                  "application/json"
              },

              credentials:
                "same-origin",

              body: JSON.stringify({
                items: [
                  {
                    id:
                      this.variantId,
                    quantity: 1
                  }
                ],

                sections:
                  sections,

                sections_url:
                  window.location.pathname
              })
            }
          );

          const responseData =
            await response.json();

          if (
            !response.ok ||
            responseData.status
          ) {
            throw new Error(
              responseData.description ||
                responseData.message ||
                NK_UPSELL_TEXT.addFailed
            );
          }

          const cartNotification =
            document.querySelector(
              "cart-notification"
            );

          if (
            !cartNotification ||
            typeof cartNotification.renderContents !==
              "function"
          ) {
            throw new Error(
              NK_UPSELL_TEXT.cartUpdateFailed
            );
          }

          let sectionData =
            responseData.sections;

          if (!sectionData) {
            sectionData =
              await this.getFreshSections();
          }

          cartNotification.renderContents({
            ...responseData,
            sections:
              sectionData
          });

        } catch (error) {
          console.error(
            "Cart upsell:",
            error
          );

          this.button.disabled =
            false;

          this.button.removeAttribute(
            "aria-busy"
          );

          this.button.innerHTML =
            originalHTML;

          if (this.errorMessage) {
            this.errorMessage.textContent =
              error.message ||
              NK_UPSELL_TEXT.addFailedRetry;

            this.errorMessage.hidden =
              false;
          }
        }
      }
    }
  );
}